import { render, staticRenderFns } from "./XiTunBaoSelectedGoods.vue?vue&type=template&id=07a0b44f&scoped=true"
import script from "./XiTunBaoSelectedGoods.vue?vue&type=script&lang=js"
export * from "./XiTunBaoSelectedGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a0b44f",
  null
  
)

export default component.exports